import Vue from 'vue';
import VueI18n from 'vue-i18n';
import ms from './i18n/ms/index';
import en from './i18n/en/index';

Vue.use(VueI18n);

const messages = {
  ms,
  en,
};

const i18n = new VueI18n({
  // locale: locale,
  messages,
});

export default i18n;
